import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-beneficio-completo',
  templateUrl: './beneficio-completo.component.html',
  styleUrls: ['./beneficio-completo.component.scss']
})

export class BeneficioCompletoComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
